/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { claim } from '../fn/form-risk-entry/claim';
import { Claim$Params } from '../fn/form-risk-entry/claim';
import { create } from '../fn/form-risk-entry/create';
import { Create$Params } from '../fn/form-risk-entry/create';
import { deleteEntry } from '../fn/form-risk-entry/delete-entry';
import { DeleteEntry$Params } from '../fn/form-risk-entry/delete-entry';
import { FormRiskEntry } from '../models/form-risk-entry';
import { get } from '../fn/form-risk-entry/get';
import { Get$Params } from '../fn/form-risk-entry/get';
import { getWithAudit } from '../fn/form-risk-entry/get-with-audit';
import { GetWithAudit$Params } from '../fn/form-risk-entry/get-with-audit';
import { list } from '../fn/form-risk-entry/list';
import { List$Params } from '../fn/form-risk-entry/list';
import { update } from '../fn/form-risk-entry/update';
import { Update$Params } from '../fn/form-risk-entry/update';
import { updateBulk } from '../fn/form-risk-entry/update-bulk';
import { UpdateBulk$Params } from '../fn/form-risk-entry/update-bulk';

@Injectable({ providedIn: 'root' })
export class FormRiskEntryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formRiskEntryControllerList()` */
  static readonly FormRiskEntryControllerListPath = '/forms/{formId}/risk-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list()` instead.
   *
   * This method doesn't expect any request body.
   */
  list$Response(params: List$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FormRiskEntry>>> {
    return list(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list(params: List$Params, context?: HttpContext): Observable<Array<FormRiskEntry>> {
    return this.list$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormRiskEntry>>): Array<FormRiskEntry> => r.body)
    );
  }

  /** Path part for operation `formRiskEntryControllerUpdate()` */
  static readonly FormRiskEntryControllerUpdatePath = '/forms/{formId}/risk-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update$Response(params: Update$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FormRiskEntry>>> {
    return update(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update(params: Update$Params, context?: HttpContext): Observable<Array<FormRiskEntry>> {
    return this.update$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormRiskEntry>>): Array<FormRiskEntry> => r.body)
    );
  }

  /** Path part for operation `formRiskEntryControllerCreate()` */
  static readonly FormRiskEntryControllerCreatePath = '/forms/{formId}/risk-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: Create$Params, context?: HttpContext): Observable<StrictHttpResponse<FormRiskEntry>> {
    return create(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: Create$Params, context?: HttpContext): Observable<FormRiskEntry> {
    return this.create$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormRiskEntry>): FormRiskEntry => r.body)
    );
  }

  /** Path part for operation `formRiskEntryControllerGet()` */
  static readonly FormRiskEntryControllerGetPath = '/forms/{formId}/risk-entry/{formRiskEntryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `get()` instead.
   *
   * This method doesn't expect any request body.
   */
  get$Response(params: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<FormRiskEntry>> {
    return get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  get(params: Get$Params, context?: HttpContext): Observable<FormRiskEntry> {
    return this.get$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormRiskEntry>): FormRiskEntry => r.body)
    );
  }

  /** Path part for operation `formRiskEntryControllerDeleteEntry()` */
  static readonly FormRiskEntryControllerDeleteEntryPath = '/forms/{formId}/risk-entry/{formRiskEntryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEntry()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEntry$Response(params: DeleteEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEntry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEntry(params: DeleteEntry$Params, context?: HttpContext): Observable<void> {
    return this.deleteEntry$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `formRiskEntryControllerGetWithAudit()` */
  static readonly FormRiskEntryControllerGetWithAuditPath = '/forms/{formId}/risk-entry/{formRiskEntryId}/with-audit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWithAudit()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithAudit$Response(
    params: GetWithAudit$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormRiskEntry>> {
    return getWithAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWithAudit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWithAudit(params: GetWithAudit$Params, context?: HttpContext): Observable<FormRiskEntry> {
    return this.getWithAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormRiskEntry>): FormRiskEntry => r.body)
    );
  }

  /** Path part for operation `formRiskEntryControllerClaim()` */
  static readonly FormRiskEntryControllerClaimPath = '/forms/{formId}/risk-entry/claim';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claim()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claim$Response(params: Claim$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FormRiskEntry>>> {
    return claim(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claim$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claim(params: Claim$Params, context?: HttpContext): Observable<Array<FormRiskEntry>> {
    return this.claim$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormRiskEntry>>): Array<FormRiskEntry> => r.body)
    );
  }

  /** Path part for operation `formRiskEntryControllerUpdateBulk()` */
  static readonly FormRiskEntryControllerUpdateBulkPath = '/forms/{formId}/risk-entry/bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBulk$Response(
    params: UpdateBulk$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormRiskEntry>>> {
    return updateBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBulk(params: UpdateBulk$Params, context?: HttpContext): Observable<Array<FormRiskEntry>> {
    return this.updateBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormRiskEntry>>): Array<FormRiskEntry> => r.body)
    );
  }
}
